// extracted by mini-css-extract-plugin
export default {"mCard":"cD-z","image":"dD-z","imageNoBackground":"eD-z","imageHasCategory":"fD-z","fullWidth":"gD-z"};